import React from 'react';
import { AnchorIcon, CompassIcon, BuildingIcon, SunsetIcon } from 'lucide-react';
export const Itinerary = () => {
  return <section id="itinerario" className="section bg-navy/5 overflow-hidden">
      <div className="container relative">
        {/* Decorative elements */}
        <div className="absolute top-20 left-10 w-16 h-16 border-2 border-turquoise/30 rounded-full"></div>
        <div className="absolute bottom-40 right-20 w-24 h-24 border-2 border-turquoise/30 rounded-full"></div>
        <div className="absolute top-40 right-40 w-8 h-8 bg-turquoise/20 rounded-full"></div>
        <div className="text-center mb-16 reveal-up">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-6">
            Tu Recorrido por el{' '}
            <span className="text-turquoise">Río Guayas</span>
          </h2>
          <div className="w-24 h-1 bg-turquoise mx-auto mb-8"></div>
          <p className="max-w-2xl mx-auto text-lg">
            Un viaje de aproximadamente 45 minutos donde descubrirás Guayaquil
            desde su elemento más emblemático: el agua
          </p>
        </div>
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-turquoise/30 z-0"></div>
            {/* Timeline steps */}
            <div className="timeline-container">
              <div className="timeline-step reveal-right">
                <div className="timeline-icon">
                  <AnchorIcon className="h-8 w-8 text-white" />
                </div>
                <div className="timeline-content">
                  <h3 className="font-playfair text-xl font-semibold mb-2">
                    Salida desde el Muelle
                  </h3>
                  <p>
                    Te recibimos en el exclusivo Muelle del Yacht Club Naval con
                    una bebida de bienvenida mientras te explicamos el
                    recorrido.
                  </p>
                </div>
              </div>
              <div className="timeline-step reveal-left">
                <div className="timeline-icon">
                  <CompassIcon className="h-8 w-8 text-white" />
                </div>
                <div className="timeline-content">
                  <h3 className="font-playfair text-xl font-semibold mb-2">
                    Recorrido Panorámico
                  </h3>
                  <p>
                    Navegamos por el majestuoso río Guayas, disfrutando de la
                    brisa y las vistas únicas que solo el agua puede ofrecer.
                  </p>
                </div>
              </div>
              <div className="timeline-step reveal-right">
                <div className="timeline-icon">
                  <BuildingIcon className="h-8 w-8 text-white" />
                </div>
                <div className="timeline-content">
                  <h3 className="font-playfair text-xl font-semibold mb-2">
                    Vista del Skyline
                  </h3>
                  <p>
                    Admiramos la impresionante silueta urbana de Guayaquil, sus
                    edificios emblemáticos y el contraste entre lo moderno y lo
                    histórico.
                  </p>
                </div>
              </div>
              <div className="timeline-step reveal-left">
                <div className="timeline-icon">
                  <SunsetIcon className="h-8 w-8 text-white" />
                </div>
                <div className="timeline-content">
                  <h3 className="font-playfair text-xl font-semibold mb-2">
                    Regreso al Atardecer
                  </h3>
                  <p>
                    Volvemos al muelle mientras contemplamos cómo el sol se
                    despide tiñendo el cielo y el río con espectaculares tonos
                    dorados y rojizos.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-16 pb-24 text-center reveal-up">
            <div className="inline-block bg-white py-6 px-10 rounded-lg shadow-md w-full max-w-md mx-auto">
              <p className="text-lg font-playfair mb-4 text-navy">
                Muy pronto podrás reservar tu paseo desde aquí
              </p>
              <button className="btn-secondary w-full md:w-auto px-8 py-3">
                Mantente informado
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Wave decoration */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full" preserveAspectRatio="none">
          <path fill="#FFFFFF" fillOpacity="1" d="M0,224L80,229.3C160,235,320,245,480,218.7C640,192,800,128,960,106.7C1120,85,1280,107,1360,117.3L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path>
        </svg>
      </div>
    </section>;
};